<template>
<div id="room-type" :class="{'pa-2 ma-2': $vuetify.breakpoint.mdAndUp}" style="padding-bottom: 70px !important">
    <im-header :loading="loading_data">
        <template v-slot:title>
            <v-icon size="32" class="" @click="back()">keyboard_arrow_left</v-icon>
            <span v-if="$route.params.id">
                <template v-if="name">{{name}}</template>
                <template v-else>{{ $t('room_type_slug.' + item.slug ) }}</template>
            </span>
            <span v-else>{{ $t('room_type.title_create') }}</span>
        </template>
        <template v-slot:button>
            <template v-if="$vuetify.breakpoint.smAndUp">
                <v-btn-toggle class="group-btn" mandatory v-model="item.close_out">
                    <v-btn color="green" small :value="false">{{ $t('rate_plan.status.active') }}</v-btn>
                    <v-btn color="red" small :value="true">{{ $t('rate_plan.status.inactive') }}</v-btn>
                </v-btn-toggle>
            </template>
            <template v-else>
                <im-switch :value="item.close_out" @update="item.close_out = $event"></im-switch>
            </template>
        </template>
        <!-- <v-btn-toggle slot="button" class="group-btn" mandatory v-model="item.close_out">
            <v-btn color="green" small :value="false">{{ $t('rate_plan.status.active') }}</v-btn>
            <v-btn color="red" small :value="true">{{ $t('rate_plan.status.inactive') }}</v-btn>
        </v-btn-toggle> -->
    </im-header>

    <v-alert class="mx-3 my-0" dismissible v-if="item.close_out" elevation="3" text outlined color="deep-orange" icon="warning">
        Aceasta camera nu este activa pentru vanzare
    </v-alert>

    <v-container fluid>
        <v-row class="im-card-items">
            <v-col md="4" cols="12">
                <v-skeleton-loader v-if="loading_data" class="mx-auto" type="card-heading,list-item@5"></v-skeleton-loader>
                <im-room-type-description v-else class="im-card" :item="item" :extra_beds="extra_beds" :single_stay="single_stay" :children="children" :room_standards="room_standards" />
            </v-col>
            <v-col md="8" cols="12">
                <v-skeleton-loader v-if="loading_data" class="mx-auto" type="card-heading,list-item@5"></v-skeleton-loader>
                <im-room-type-facilities v-else class="im-card" :item="item" :room_facilities="room_facilities" :selected_facilities_ids="selected_facilities" @updateFacilities="updateFacilities($event)" />
            </v-col>
            <v-col md="4" cols="12">
                <v-skeleton-loader v-if="loading_data" class="mx-auto" type="card-heading,list-item@4"></v-skeleton-loader>
                <im-room-type-association v-else class="im-card" :item="item" :hotel_id="hotel.id" :rate_plans_selected="rate_plans_selected" @updateRatePlan="updateRatePlan($event)" />
            </v-col>
            <v-col md="8" cols="12">
                <v-skeleton-loader v-if="loading_data" class="mx-auto" type="card-heading,list-item@4"></v-skeleton-loader>
                <im-room-type-media v-else class="im-card" :item="item" :hotel_id="hotel.id" :new_images="new_images" @addPhotos="addPhotos($event)" @updateDefaultPhoto="updateDefaultPhoto($event)" />
            </v-col>
        </v-row>
    </v-container>

    <!--delete dialog-->
    <im-dialog-confirmation :dialog="delete_dialog" @cancel="delete_dialog=false" :loading="loading_delete" @delete="destroy()">
        <span slot="text-confirmation">{{ $t('room_type.message_delete_confimation') }}</span>
    </im-dialog-confirmation>
    <!--./delete dialog -->

    <v-snackbar v-model="error_data" color="error" bottom left>
        <div>
            <template v-for="error_field in fields_error">
                <div>
                    {{error_field}}
                </div>
            </template>
        </div>
    </v-snackbar>

    <!-- footer -->
    <im-footer :create='!!(item.id)' :update="modified&&(new_images.length==0)&&!modified_rate_plans_selection&&(default_image_id==null)" :loading="loading_save" @save="saveItem()" @refresh="refresh()" @delete="deleteItem()" />
    <!-- ./ footer -->
</div>
</template>

<script>
import {
    mapActions
} from 'vuex'

import logger from "../../logger.js";
import defaults from '../../components/utils/PropDefaults.js';
import IMHeader from '../../components/utils/IMHeader.vue';
import IMFooter from '../../components/utils/IMFooter.vue';
import IMSwitch from '../../components/small-components/IMSwitch.vue';
import ImDialogConfirmation from '../../components/utils/ImDialogConfirmation.vue';
import IMRoomTypeFacilities from "../../components/items/RoomType/items/Facilities.vue";
import IMRoomTypeMedia from "../../components/items/RoomType/items/MediaRoom.vue";
import IMRoomTypeDescription from "../../components/items/RoomType/items/Description.vue";
import IMRoomTypeAssociation from "../../components/items/RoomType/items/Association.vue";

export default {
    props: ['hotel'],
    name: `room-type`,
    components: {
        "im-room-type-description": IMRoomTypeDescription,
        "im-room-type-association": IMRoomTypeAssociation,
        "im-room-type-facilities": IMRoomTypeFacilities,
        "im-room-type-media": IMRoomTypeMedia,
        "im-header": IMHeader,
        "im-footer": IMFooter,
        "im-switch": IMSwitch,
        "im-dialog-confirmation": ImDialogConfirmation
    },

    data() {
        return {
            error_data: false,
            fields_error: [],
            name: defaults.room_type_name,
            //config
            room_facilities: [],
            room_standards: [],
            config: {},
            // room extra
            single_stay: false,
            extra_beds: false,
            children: false,

            loading_save: false,
            loading_data: false,
            loading_delete: false,
            delete_dialog: false,

            new_images: [],
            default_image_id: null,
            rate_plans_selected: [],
            selected_facilities: [],
            original_rate_plans_selected: [],
            original_selected_facilities: [],

            modified: false,
            modified_rate_plans: false,
            modified_rate_plans_selection: false,
            original_item: this.$clone(defaults.room_type_item),
            item: this.$clone(defaults.room_type_item),
        };
    },

    watch: {
        '$route.params': {
            async handler() {
                await this.hotel;
                // react to route changes...
                if(this.$route.params.hotel_slug !== this.hotel.slug) {
                    await this.checkSlug(this.$route.params.hotel_slug)
                } else {
                    this.loading_data = true;
                    await this.getItemConfig()
                    await this.getInfoHotel()
                    await this.getItem()

                    this.$nextTick(function () {
                        this.loading_data = false;
                    });

                }
            },
            deep: true,
            immediate: true
        },

        'hotel.id': function (new_hotel, old_hotel) {
            if(new_hotel !== JSON.parse(localStorage.getItem('hotel'))
                .id) {
                this.$router.push({
                    path: '/' + this.hotel.slug + +'/room-types'
                });
            }
        },

        item: {
            handler: function () {
                this.modified = (JSON.stringify({ ...this.item
                }) == JSON.stringify({ ...this.original_item
                }));
            },
            deep: true
        },
        rate_plans_selected: {
            handler: function () {
                this.modified_rate_plans_selection = !(JSON.stringify({ ...this.rate_plans_selected
                }) == JSON.stringify({ ...this.original_rate_plans_selected
                }));
            },
            deep: true
        },

    },

    methods: {
        ...mapActions('alert', ['success', 'error']),

        checkSlug(slug) {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/console/v1/hotels/check-slug";
            let params = {
                params: {
                    slug: slug
                }
            };

            return this.$axios.get(endpoint, params)
                .then(response => {
                    if(response.data.exists) {
                        this.$emit('changeHotel', [response.data.hotel_id, false]);
                    } else {
                        this.error("Oops, something went wrong!");
                        this.$router.push({
                            path: '/dashboard',
                        });
                    }
                    return new Promise(function (resolve, reject) {
                        resolve(true);
                    });
                })
                .catch(error => {
                    console.log(error);
                    this.error("Oops, something went wrong!");
                })
                .finally(() => {});
        },


        getItemConfig() {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/console/v1/config';

            return this.$axios.get(endpoint)
                .then(response => {
                    let room_standards = [];
                    Object.keys(response.data.room_slugs)
                        .forEach(function (item) {
                            if(item !== "king" && item !== "queen") {
                                let all_types = [];
                                Object.entries(response.data.room_slugs[item])
                                    .forEach(([key, value]) => {
                                        all_types.push({
                                            slug: key,
                                            text: value
                                        })
                                    });
                                room_standards.push({
                                    slug: item,
                                    description: response.data.room_type_standards[item],
                                    types: all_types
                                })
                            }
                        })
                    this.room_facilities = response.data.room_facilities;
                    this.config = response.data;
                    this.room_standards = room_standards;

                    return new Promise(function (resolve, reject) {
                        resolve(response.data);
                    });
                })
        },


        getInfoHotel() {

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/console/v1/hotels/" + this.hotel.id;

            return this.$axios.get(endpoint)
                .then(response => {
                    let hotel_data = response.data;
                    if(hotel_data.static.policy.children.allowed == '0') {
                        this.children = false;
                    }
                    if(hotel_data.static.policy.children.allowed == '1') {
                        this.children = true;
                    }
                    if(hotel_data.static.policy.extra_beds && hotel_data.static.policy.extra_beds.value !== null) {
                        this.extra_beds = true;
                    } else {
                        this.extra_beds = false;
                    }
                    if(hotel_data.static.policy.single_stay && hotel_data.static.policy.single_stay.value !== null) {
                        if(hotel_data.static.policy.single_stay.allowed && hotel_data.static.policy.single_stay.allowed == '0') {
                            this.single_stay = false;
                        } else {
                            this.single_stay = true;
                        }
                    } else {
                        this.single_stay = false;
                    }

                    this.currency = hotel_data.static.defaults.currency;

                    if(hotel_data.unit_type == 'hostel') {
                        let filter_rooms = this.room_standards.filter(item => (item.slug === 'mixed-dormitory') || (item.slug === 'women-dormitory') || (item.slug === 'men-dormitory'));
                        this.room_standards = filter_rooms;
                    } else {
                        let filter_rooms = this.room_standards.filter(item => (item.slug !== 'mixed-dormitory') && (item.slug !== 'women-dormitory') && (item.slug !== 'men-dormitory'));
                        this.room_standards = filter_rooms;
                    }
                })
                .catch(error => {
                    console.log(error);
                    this.error("Oops, something went wrong!");
                })
                .finally(() => {});
        },

        getItem() {
            if(this.$route.params.id == undefined) {
                this.loading_data = false;
                return
            }
            this.selected_facilities = [];
            this.loading_data = true;
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/console/v1/room-types/' + this.$route.params.id;

            // setup query params
            let params = {
                params: {
                    hotel_id: this.hotel.id
                }
            };

            this.$axios.get(endpoint, params)
                .then(response => {
                    // redirect when hotel_id doesn't macth
                    if(this.hotel.id !== response.data.hotel_id) {
                        this.error(this.$t('room_type.message_no_access'));
                        this.$router.push({
                            path: '/dashboard'
                        });
                        return
                    }
                    this.item = this.$clone(response.data);
                    response.data.rate_plans.forEach(function (rate_plan) {
                        this.rate_plans_selected.push(rate_plan.id)
                    }.bind(this))

                    // for facilities
                    let facilities = response.data.config.facilities;
                    let facilities_ids = [];
                    if(Array.isArray(facilities)) {
                        facilities.forEach(function (item) {
                            this.selected_facilities.push(Number(item.id))
                        }.bind(this))
                    } else {
                        if(response.data.config.facilities) {
                            facilities_ids = Object.keys(response.data.config.facilities)
                            facilities_ids.forEach(function (item) {
                                if(facilities[item].id == item) {
                                    this.selected_facilities.push(Number(item))
                                }
                            }.bind(this))
                        }
                    }

                    this.original_selected_facilities = this.$clone(this.selected_facilities);
                    this.original_rate_plans_selected = this.$clone(this.rate_plans_selected);
                    this.name = response.data.name;
                    this.original_item = this.$clone(this.item);
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    this.loading_data = false;
                })
        },

        validateRoom() {
            let valid_room = true;
            this.fields_error = [];
            if(!this.item.standard) {
                this.fields_error.push('Standardul camerei este obligatoriu')
            }
            if(!this.item.slug) {
                this.fields_error.push('Tipul detaliat al camerei este obligatoriu')
            }
            if(!this.item.config.occupancy) {
                this.fields_error.push('Ocupanta camerei este obligatorie')
            }
            if(this.fields_error.length) {
                this.error_data = true;
                logger.error(JSON.stringify(this.fields_error), 'RoomType.vue')
                    .then(() => null);
            }


            return valid_room && !this.fields_error.length
        },

        saveItem() {
            // check all data required
            this.loading_save = true;
            if(!this.validateRoom()) {
                this.loading_save = false;
                return
            }

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/console/v1/room-types/';

            let room = this.$clone(this.item);
            room.images = this.$clone(this.new_images);
            room.rate_plans = this.rate_plans_selected;

            let params = {
                hotel_id: this.hotel.id
            };

            if(this.default_image_id) {
                this.$axios.post(endpoint + this.$route.params.id + "/main-image/" + this.default_image_id, params)
                    .then(response => {
                        this.success(this.$t('room_type.message_default_image'));
                    })
                    .catch(error => {
                        if(error.response.status === 413) {
                            this.error("Upload to high! Max 10Mb");
                        } else {
                            this.error("Oops, something went wrong!");
                        }
                    })
                    .finally(() => {
                        this.default_image_id = null;
                    });
            }

            if(this.$route.params.id !== undefined) {
                this.$axios.put(endpoint + this.$route.params.id, room)
                    .then(response => {
                        this.success(this.$t('room_type.message_edited_room'));
                        this.getItem();
                        this.new_images = [];
                    })
                    .catch(error => {
                        console.log(error);
                        this.error('Oops, something went wrong!');
                    })
                    .finally(() => {
                        this.loading_save = false;
                    });
            } else {
                room.hotel_id = this.hotel.id;
                delete room.id;
                this.$axios.post(endpoint, room)
                    .then(response => {
                        this.success(this.$t('room_type.message_created_room'));
                        this.$router.push({
                            path: '/' + this.hotel.slug + '/room-types'
                        });
                    })
                    .catch(error => {
                        console.log(error);
                        this.error('Oops, something went wrong!');
                    })
                    .finally(() => {
                        this.loading_save = false;
                    });
            }
        },

        deleteItem() {
            this.delete_dialog = true;
        },

        destroy() {
            this.loading_delete = true;
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/console/v1/room-types/";

            // setup query params
            let params = {
                params: {
                    hotel_id: this.item.hotel_id
                }
            };

            // call delete endpoint
            this.$axios.delete(endpoint + this.$route.params.id, params)
                .then(response => {
                    this.success(this.$t('room_type.message_deleted_room'));
                    this.delete_dialog = false;
                })
                .catch(error => {
                    this.error("Oops, something went wrong!");
                    console.error(error);
                })
                .finally(() => {
                    this.loading_delete = false;
                    this.$router.push({
                        path: '/' + this.hotel.slug + '/room-types'
                    });
                });
        },

        updateRatePlan(value) {
            this.rate_plans_selected = value;
        },

        updateFacilities(value) {
            this.selected_facilities = value;
            let data_selection = {};
            value.forEach(function (item) {
                data_selection[item] = {
                    id: item,
                    price: null
                }
            });
            this.item.config.facilities = data_selection;
        },

        addPhotos(value) {
            this.new_images = value;
        },

        updateDefaultPhoto(id) {
            let value = id.toString();
            if(value.includes("abc")) {
                // photo is a new one added
                let value_index = this.new_images.findIndex(photo => photo.id === value);
                this.new_images[value_index].default = true;
                this.default_image_id = null;
            } else {
                // photo is an old one and we need to call api
                this.default_image_id = id;
            }
        },

        back() {
            defaults.room_type_name = "";
            this.$router.push({
                path: '/' + this.hotel.slug + '/room-types'
            });
        },

        refresh() {
            this.new_images = [];
            this.default_image_id = null;
            this.rate_plans_selected = [];
            if(!this.$route.params.id) {
                this.item = this.$clone(defaults.room_type_item)
            } else {
                this.getItem();
            }
        },

    }
};
</script>
